// QR Code Types based on swagger.json

export type QRCodeType = 
  | "Compose SMS"
  | "Go to website"
  | "Download file"
  | "Compose Email"
  | "Visit Instagram"
  | "Visit Facebook"
  | "Go to Google Reviews Page";

export type QRCodeDestinationType = 
  | "URL"
  | "SMS"
  | "Contact Card"
  | "Instagram"
  | "Facebook"
  | "Google Review";

export type QRCodeFileFormat = "PNG" | "JPG" | "SVG";

export type QRCodeSize = "Small" | "Medium" | "Large";

export interface QRCodeSizeConfig {
  Small: { width: number; height: number };
  Medium: { width: number; height: number };
  Large: { width: number; height: number };
}

export const QR_CODE_SIZES: QRCodeSizeConfig = {
  Small: { width: 200, height: 200 },
  Medium: { width: 600, height: 600 },
  Large: { width: 1200, height: 1200 },
};

export interface QRCodeStylingOptions {
  foregroundColor: string;
  backgroundColor?: string;
  cornerRadius?: number;
  margin?: number;
  shape?: 'square' | 'circle';
  dotType?: 'square' | 'circle' | 'rounded';
  hasFrame?: boolean;
  frameTopText?: string;
  frameBottomText?: string;
  hasLogo?: boolean;
  logoType?: 'instagram' | 'facebook' | 'google' | 'custom';
  customLogoUrl?: string;
  // Border plugin options
  hasBorder?: boolean;
  borderThickness?: number;
  borderColor?: string;
  borderRound?: number;
  borderDasharray?: string;
  borderInnerThickness?: number;
  borderInnerColor?: string;
  borderOuterThickness?: number;
  borderOuterColor?: string;
  // Border text decorations
  topText?: string;
  topTextStyle?: string;
  bottomText?: string;
  bottomTextStyle?: string;
  leftText?: string;
  leftTextStyle?: string;
  rightText?: string;
  rightTextStyle?: string;
}

export interface QRCodeSaveParameters {
  styling: QRCodeStylingOptions;
  previewFormat: QRCodeFileFormat;
  previewSize: QRCodeSize;
  destinationData: Record<string, unknown>;
}

export interface EntityQRCodeParametersSimpleView {
  // Empty for a code generated from a keyword: there is no record to edit by id or to archive.
  id: string | null;
  keywordId: string | null;
  name: string;
  companyId: string;
  qrcodeTypeId: number;
  qrcodeTypeName: string;
  qrCodeData: string;
  parameters: string | null;
  // Derived from an active keyword, with no stored record behind it.
  generated: boolean;
  authorIsCurrentUser: boolean;
  createdBy: string | null;
  updatedBy: string | null;
  dateCreated: string;
  dateUpdated: string;
}

export interface EntityQRCodeParametersUpdateBody {
  parameters: string;
  name: string;
}

export interface EntityQRCodeParametersCreateBody {
  type: QRCodeType;
  // Only a Compose SMS code carries one, and a keyword holds one code at a time.
  keywordId: string | null;
  text: string;
  data: string;
  parameters: string;
  name: string;
}

export type QRCodeSearchSort =
  | 'name_asc' | 'name_desc'
  | 'type_asc' | 'type_desc'
  | 'date_created_asc' | 'date_created_desc'
  | 'date_updated_asc' | 'date_updated_desc';

export interface QRCodesSearchParams {
  companyId: string;
  query?: string;
  type?: QRCodeType;
  sort: QRCodeSearchSort;
  limit: number;
  offset: number;
}

export interface QRCodesSearchResponse {
  items: EntityQRCodeParametersSimpleView[];
  count: number;
}

export interface CompanyQRCodeParametersSimpleView {
  id: string;
  companyId: string;
  name: string;
  parameters: string;
  createdBy: string;
  updatedBy: string;
  dateCreated: string;
  dateUpdated: string;
}
